import type { ID } from '@octopus-do/octopus-project-core'
import { ArrowDownToLine, Trash } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'
import { useDeleteImage } from './useDeleteImage'

interface Props {
  image: { id: string; value: string }
  nodeId: ID
  readOnly: boolean
  hasAccess: boolean
}

export const Image: React.FC<Props> = ({
  image,
  nodeId,
  hasAccess,
  readOnly,
}) => {
  const handleDeleteImg = useDeleteImage(nodeId)

  return (
    <div className={css.image_container}>
      <img src={image.value} alt="" className={css.image} />

      {hasAccess && !readOnly && (
        <div className={css.image_buttons}>
          <a href={image.value} className={css.image_button} download>
            <ArrowDownToLine />
          </a>
          <button
            className={clsJoin(css.image_button, css.image_button_delete)}
            onClick={() => handleDeleteImg(image.id)}
          >
            <Trash />
          </button>
        </div>
      )}
    </div>
  )
}
